import React from "react";
import { useTranslation } from "react-i18next";
import { TransformedProduct } from "../../../product/types/productApiTypes";
import WishlistPageItem from "./WishlistPageItem";

interface WishlistTableProps {
  products: TransformedProduct[];
}

const WishlistTable: React.FC<WishlistTableProps> = ({ products }) => {
  const { t } = useTranslation();

  return (
    <div className="wishlist-table">
      {/* Header Row (Hidden on mobile via CSS) */}
      <div className="wishlist-table__header">
        <div className="wishlist-table__header-cell wishlist-table__header-cell--remove">
          <span className="sr-only">
            {t("wishlistPage.wishlistTable.remove", "Remove")}
          </span>
        </div>
        <div className="wishlist-table__header-cell wishlist-table__header-cell--image">
          <span className="sr-only">
            {t("wishlistPage.wishlistTable.product", "Image")}
          </span>
        </div>
        <div className="wishlist-table__header-cell wishlist-table__header-cell--name">
          {t("wishlistPage.wishlistTable.product", "Product")}
        </div>
        <div className="wishlist-table__header-cell wishlist-table__header-cell--price">
          {t("wishlistPage.wishlistTable.price", "Price")}
        </div>
        <div className="wishlist-table__header-cell wishlist-table__header-cell--stock">
          {t("wishlistPage.wishlistTable.stockStatus", "Stock Status")}
        </div>
        <div className="wishlist-table__header-cell wishlist-table__header-cell--actions">
          <span className="sr-only">
            {t("wishlistPage.wishlistTable.addToCart", "Actions")}
          </span>
        </div>
      </div>

      {/* Body */}
      <div className="wishlist-table__body">
        {products.map((product) => (
          <WishlistPageItem key={product.id} product={product} />
        ))}
      </div>
    </div>
  );
};

export default WishlistTable;
